export const images = {
  mainImage: require("./mainImage.png"),
  down: require("./down.png"),
  left: require("./left.png"),
  phone: require("./phone.png"),
  updateUser: require("./user2.png"),
  up: require("./up.png"),
  user: require("./user.png"),
  visa: require("./visa.png"),
  masterCard: require("./mastercard.png"),
  agent: require("./agent.png"),
  success: require("./success.png"),
  mainMobile: require("./mainMobile.png"),
  errMobile: require("./errMobile.png"),
  close: require("./close.png"),
  baby: require("./baby.png"),
  babyMobile: require("./babyMobile.png"),
  card: require("./card.png"),
  qr: require("./qr.png"),
  smallCard: require("./smallCard.png"),
  smallEmail: require("./smallEmail.png"),
  question: require("./question.png"),
  apay: require("./apay.png"),
  gpay: require("./gpay.png"),
  share: require("./share.png"),
  link: require("./link.png"),
  globalBlueSuccess: require("./globalBlueSuccess.png"),
  globalBlueError: require("./globalBlueError.png"),
  pcPlus1: require("./pcPlus1.png"),
  pcPlus2: require("./pcPlus2.png"),
  pcPlus3: require("./pcPlus3.png"),
  message: require("./message.png"),
  phoneApp: require("./phoneApp.png"),
  smallLogo: require("./smallLogo.png"),
  appstore: require("./appstore.png"),
  googleplay: require("./googleplay.png"),
  phoneIcon: require("./phone.png"),
  emailIcon: require("./emailIcon.png"),
  cardPopupImage: require("./cardPopupImage.png"),
  taxRefundImage: require("./taxRefundImage.png"),
  arrowleftRound: require("./arrowleftRound.png"),
  image1: require("./image1.png"),
  image2: require("./image2.png"),
  image3: require("./image3.png"),
  image4: require("./image4.png"),
  image5: require("./image5.png"),
  image6: require("./image6.png"),
  image1Mobile: require("./mobile/image1.png"),
  image2Mobile: require("./mobile/image2.png"),
  image3Mobile: require("./mobile/image3.png"),
  image4Mobile: require("./mobile/image4.png"),
  image5Mobile: require("./mobile/image5.png"),
  image6Mobile: require("./mobile/image6.png"),
};
